module.exports = __webpack_public_path__ + "media/images/application/template/icon--download-compact-be211a94bc3002a2cc585d2b6dbfa4dd.svg";